module.exports = __webpack_public_path__ + "static/img/legend_xa_spanish_dark.28d8697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_spanish_dark.png
// module id = +Q/V
// module chunks = 79